import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { SmartTireService } from 'src/app/services/feature/smartTire/smart-tire.service';
import { EndasureValueDisclaimerComponent } from '../../endasure/endasure-value-disclaimer/endasure-value-disclaimer.component';

@Component({
  selector: 'app-smarttire-vistor-info',
  templateUrl: './smarttire-vistor-info.component.html',
  styleUrl: './smarttire-vistor-info.component.scss',
  standalone: false
})
export class SmarttireVistorInfoComponent {

  private destroy$ = new Subject<void>();

  constructor(private SmartTireService: SmartTireService, private cdr: ChangeDetectorRef, private dialog: MatDialog,) { }

  vistorInfoForm = new FormGroup({
    firstName: new FormControl(null),
    lastName: new FormControl(null),
    eMail: new FormControl(null),
    valueDisclaimer: new FormControl(false, { validators: Validators.required }),
  });

  get form() {
    return this.vistorInfoForm.controls;
  }



  ngOnInit() {

    this.SmartTireService.vistInfoData$.pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log(data);
        if (data != null) {
          this.vistorInfoForm.patchValue({
            firstName: data.firstName || null,
            lastName: data.lastName || null,
            eMail: data.eMail || null,
            valueDisclaimer: data.valueDisclaimer || false,
          });
        }
        // console.log('vistInfoData',data);

      })


    this.vistorInfoForm.controls.valueDisclaimer.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      console.log(value);
      this.SmartTireService.valueDisclaimer$.next(value);
      this.cdr.detectChanges();
    });

    // this.SmartTireService.resetForms$.pipe(takeUntil(this.destroy$))
    // .subscribe(()=>{     
    //     this.resetForm();           
    //   })
    //this.storeDataOnChange();
    // this.vistorInfoForm.valueChanges.subscribe(x=>{
    //   this.storeDataOnChange();
    // })

  }


  storeDataOnChange() {
    if (this.vistorInfoForm.valid) {
      this.SmartTireService.vistInfoData$.next(this.vistorInfoForm.value);
      // this.SmartTireService.TableCalculation();
      this.cdr.detectChanges();
    }
  }

  endaSureNxt() {
    this.storeDataOnChange();
    this.SmartTireService.currentComponent$.next('fleetInfo');

  }
  openDataProtectionDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    const dialogRef = this.dialog.open(EndasureValueDisclaimerComponent);
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.vistorInfoForm.controls['valueDisclaimer'].patchValue(data);
        this.SmartTireService.vistInfoData$.next(this.vistorInfoForm.value);
      }
    });
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}